<template>
  <div
    :id="`menu-drawer--${menuId}`"
    ref="menuDrawer"
    v-clickoutside="closeMenu"
    :class="['menu-drawer', { 'menu-drawer--open': open }]"
  >
    <slot />
  </div>
</template>

<script>
  import { throttle } from '@Foundation/utilities';
  import { mapActions, mapGetters } from 'vuex';
  import { clickoutside } from '@Foundation/directives/clickoutside/clickoutside';
  import { HEADER_MOBILE } from '@Foundation/constants/headermobile';
  export default {
    name: 'MenuDrawer',
    directives: {
      clickoutside,
    },
    props: {
      menuId: { type: String, required: true },
    },
    data() {
      return {
        open: false,
        smallScreen: !window.matchMedia(`(min-width: ${HEADER_MOBILE}px)`).matches,
      };
    },
    computed: {
      ...mapGetters('menuStore', ['activeMenuId']),
    },
    watch: {
      activeMenuId(newId) {
        return newId === this.menuId ? this.updateDrawer(!this.open) : this.updateDrawer(false);
      },
    },
    mounted() {
      this.bindEvents();

      /* istanbul ignore next */
      window.addEventListener(
        'resize',
        throttle(() => {
          this.smallScreen = !window.matchMedia(`(min-width: ${HEADER_MOBILE}px)`).matches;
          this.bindEvents();
        }, 100)
      );
    },
    beforeDestroy() {
      window.removeEventListener('keydown', this.keydownEvent);
    },
    methods: {
      ...mapActions('menuStore', ['setActiveMenuId']),
      bindEvents() {
        window.removeEventListener('keydown', this.keydownEvent);
        if (this.smallScreen) {
          return;
        }
        window.addEventListener('keydown', this.keydownEvent);
        if (this.$refs.menuDrawer) {
          this.$refs.menuDrawer.addEventListener('mouseleave', this.closeMenu);
        }
      },
      keydownEvent(e) {
        if (e.keyCode !== 27) {
          return;
        }
        this.closeMenu();
      },
      updateDrawer(status) {
        this.open = status;
        this.checkDrawerOverflow();
      },
      checkDrawerOverflow() {
        if (!(!this.smallScreen && this.activeMenuId === this.menuId)) {
          return;
        }

        this.$nextTick(() => {
          this.adjustDrawerOverflow();
        });
      },
      adjustDrawerOverflow() {
        this.$refs.menuDrawer.style.left = 'unset';
        if (!this.itOverflows()) {
          return;
        }
        this.$refs.menuDrawer.style.left = `${
          this.countDoesNotClose() ? this.centerIt() : this.alignWithMenu()
        }px`;
      },
      itOverflows() {
        return this.$refs.menuDrawer.getBoundingClientRect().right > window.innerWidth;
      },
      alignWithMenu() {
        return document.querySelector('.menulist').getBoundingClientRect().left;
      },
      countDoesNotClose() {
        return (
          this.alignWithMenu() + this.$refs.menuDrawer.getBoundingClientRect().width >
          window.innerWidth
        );
      },
      centerIt() {
        return (window.innerWidth - this.$refs.menuDrawer.getBoundingClientRect().width) / 2;
      },
      closeMenu() {
        if (this.smallScreen) {
          return;
        }
        if (this.open) {
          this.setActiveMenuId(null);
        }
      },
      setAriaAttributes() {
        if (!this.smallScreen) {
          return;
        }
        this.$refs.menuDrawer.setAttribute('role', 'region');
        this.$refs.menuDrawer.setAttribute('aria-labelledby', `menu-btn--${this.menuId}`);
      },
    },
  };
</script>
